import state from './Ship/states'
import mutations from './Ship/mutations'
import actions from './Ship/actions'
import getters from './Ship/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
